import $ from 'jquery';
window.$ = $;
import '@popperjs/core';
import '@selectize/selectize';
import * as bootstrap from 'bootstrap';
import '../javascripts/bootstrap/search/region-selector';
import '../javascripts/ga/google_analytics4';
import '../javascripts/bootstrap/warning';
import '../javascripts/offer';
import '../javascripts/bootstrap/site-notice';

// Initialize Bootstrap tooltips when DOM is ready
$(function () {
  // Initialize all Bootstrap tooltips
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });
});